import { render, staticRenderFns } from "./editBank.vue?vue&type=template&id=4e0807c1&scoped=true&"
import script from "./editBank.vue?vue&type=script&lang=js&"
export * from "./editBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0807c1",
  null
  
)

export default component.exports